import UpdateCustomer from "../../../../components/@users/customers/UpdateCustomer"

import { routeTypes } from "../../../../../../hooks/useSystemRoutes"

export default function CustomerUpdatePage() {

    return (
        <UpdateCustomer 
            routeType={routeTypes.admin}
        />
    )
}       